import { ErrorResponse } from "./ErrorResponse";

export class NotFoundErrorResponse extends ErrorResponse {
    title = "An error occurred";

    description = "Unable to find your entity, please try again!";
}
